import { Outlet, Link } from 'react-router-dom';
import TopBar from '../components/TopBar';
import Logo from '../assets/img/logo.png';
import { useLocation } from 'react-router-dom';


export default function AuthLayout() {

	const location = useLocation()

	return (
		<>
			<TopBar />
			<div className='authentication'>
				<main className='bg-light-gradient min-vh-100'>
					<div className={`clearfix bg-white text-center border-bottom border-1 p-2 ${location?.pathname === '/walkthrough' ? '' : 'mb-5'}`}>
						<Link to='/'>
							<img src={Logo} alt='Logo' width={280} />
						</Link>
					</div>
					<Outlet />
				</main>
			</div>
		</>
	);
}
